import { IMongoWorkspace } from '../../interfaces/mongo-workspace.interface';

export interface IUser extends IMongoWorkspace {
    username: string;
    groupId: string;
    password: string;
}
